import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button, Chip, Description, Heading } from '@heroui/react';
import { LandingProductPreview } from './landing-product-preview';

export function LandingHero() {
  const navigate = useNavigate();

  return (
    <section id="inicio" className="scroll-mt-24">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-4 py-16 sm:px-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.05fr)] lg:py-24">
        <div className="flex flex-col items-start gap-6">
          <Chip size="sm" variant="soft" color="accent">
            Feito para condomínios
          </Chip>
          <Heading level={1} className="text-4xl font-bold leading-tight tracking-tight sm:text-5xl">
            A vaga ociosa do prédio, em movimento
          </Heading>
          <Description className="max-w-xl text-base leading-relaxed sm:text-lg">
            Moradores emprestam e alugam vagas entre si. O síndico acompanha. Ninguém discute no
            grupo do WhatsApp.
          </Description>
          <div className="flex flex-wrap items-center gap-3">
            <Button variant="primary" size="lg" onPress={() => navigate('/login')}>
              Começar agora
              <ArrowRight size={18} />
            </Button>
            <Button variant="outline" size="lg" onPress={() => {
              document.getElementById('como-funciona')?.scrollIntoView({ behavior: 'smooth' });
            }}>
              Ver como funciona
            </Button>
          </div>
          <p className="text-sm text-muted">
            PWA instalável no celular · empréstimo ou aluguel · ranking do condomínio
          </p>
        </div>

        <LandingProductPreview />
      </div>
    </section>
  );
}
